<template>
  <div class="pageContent">
    <div class="brand-header">{{ $t('product.chineseMarket') }}</div>
    <div class="brand-container">
    <ul class="brand-list">
      <li class="subtitle">Top {{ $t('product.brandRecommend') }}</li>
      <li @click="onClickBrand(index, item.brand_name_en)" :class="{ active: brandIndex === index }" v-for="(item, index) in brandList" :key="item.brandId">
        {{ item.brand_name_en }}
      </li>
    </ul>
    <div class="box">
      <div class="chart-pie" ref="chartPie"></div>
      <div class="spu-list">
        <template v-for="(item, index) in spuList">
          <div class="spu-item" :key="index" v-if="item.image">
            <el-image class="img" :src="item.image + '?x-oss-process=image/auto-orient,1/resize,m_lfit,w_240/quality,q_100/format,jpg'" fit="contain"></el-image>
            <p>{{ item.designer_id }} - {{ item.color_code }}</p>
          </div>
        </template>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { Pie } from '@antv/g2plot';
// import numberFormat from 'number-format.js'
// import { pieOptions } from './chartOptions';
import { listBrandRecommend, brandRecommendSingle, brandRecommendOfPieChart } from '../../api/dashboard.js';
// import { gioTrack } from '@/utils/gio.js';

export default {
  props: {
    vendorId: Number,
    isen: {
      type: Boolean,
      default: true,
    },
    Messages: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      spuList: [],
      brandIndex: 0,
      brandList: [],
    };
  },
  components: {},
  created() {
    this.total = 1;
  },
  mounted() {
    this.initPie();
    this.getBrandList();
  },
  methods: {
    getBrandList() {
      listBrandRecommend({
        pageNum: 1,
        pageSize: 10,
      }).then(res => {
        try {
          const data = JSON.parse(res.data);
          const brandList = data.data.rows.sort((a, b) => {
            return a.order_num - b.order_num;
          });
          this.brandList = brandList;
          if (brandList.length > 0) {
            this.getPieData();
            this.getSPUList();
          }
        } catch (error) {
          console.error(error);
        }
      })
    },
    initPie() {
      this.chartPie = new Pie(this.$refs.chartPie, {
        appendPadding: 0,
        data: [],
        angleField: 'value',
        colorField: 'type',
        radius: 0.5,
        legend: false,
        label: {
          type: 'spider',
          labelHeight: 28,
          content: '{name}\n{percentage}',
        },
        interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
        tooltip: {
          formatter: (data) => {
            return { name: data.type, value: (data.value / this.total * 100).toFixed(2) + '%' }
          },
        },
      });
      this.chartPie.render();
    },
    getPieData() {
      brandRecommendOfPieChart({
        brand_id: this.brandList[this.brandIndex].brand_id,
        pageNum: 1,
        pageSize: 1000,
      }).then(res => {
        try {
          const data = JSON.parse(res.data);
          const pieData = data.data.rows.map(item => {
            this.total += item.gmv;
            return {
              type: item.category_name,
              value: item.gmv,
            }
          })
          const sortData = pieData.sort((a, b) => {
            return b.value - a.value;
          })
          this.chartPie.changeData(sortData);
        } catch (error) {
          // console.error(error);
        }
      }).catch(() => {
        this.chartPie.changeData([]);
      })
    },
    getSPUList() {
      brandRecommendSingle({
        brand_id: this.brandList[this.brandIndex].brand_id,
        pageNum: 1,
        pageSize: 10,
      }).then(res => {
        try {
          const data = JSON.parse(res.data);
          this.spuList = data.data.rows || [];
        } catch (error) {
          // console.error(error);
        }
      }).catch(() => {
        this.spuList = [];
      })
    },
    onClickBrand(index, brandName) {
      if (index === this.brandIndex) {
        return;
      }
      this.brandIndex = index;
      this.getPieData();
      this.getSPUList();

      // gioTrack('flowLocationClick', {
      //   clickTitle: brandName,
      //   vendorId: this.vendorId,
      //   currTime: Date.now(),
      //   module: 'Top品牌推荐',
      //   column: '中国市场',
      // })
    },
  },
};
</script>

<style lang="scss" scoped>
.pageContent{
  padding: 20px;
  background: white;
}
.brand-header{
  font-size: 24px;
  margin-bottom: 20px;
}
.brand-container {
  position: relative;
  padding-left: 180px;
}
.brand-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 180px;
  font-size: 14px;

  li {
    height: 40px;
    padding-left: 12px;
    color: #666666;
    line-height: 40px;
    box-sizing: border-box;
    cursor: pointer;

    &.active {
      position: relative;
      color: #c0a37d;
      border-top: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      border-left: 1px solid #eeeeee;
      cursor: default;

      &::before {
        content: '';
        position: absolute;
        top: 11px;
        left: 0;
        width: 2px;
        height: 16px;
        background-color: #c0a37d;
      }
      &::after {
        content: '';
        position: absolute;
        top: 0;
        right: -2px;
        width: 3px;
        height: 100%;
        background-color: #fff;
        z-index: 10;
      }
    }
  }
  .subtitle {
    height: auto;
    margin-bottom: 16px;
    color: #222222;
    font-size: 16px;
    line-height: 24px;
  }
}
.box {
  position: relative;
  padding-left: 37.5%;
  min-height: 522px;
  border: 1px solid #eeeeee;
}
.chart-pie {
  position: absolute;
  top: 0;
  left: 0;
  width: 37.5%;
  height: 100%;
}
.spu-list {
  width: 100%;
  padding-top: 10px;
  padding-bottom: 10px;
  overflow: hidden;

  .spu-item {
    float: left;
    width: 16%;
    margin-top: 10px;
    margin-left: 2%;
    margin-right: 2%;
  }
  .img {
    display: block;
    width: 100%;
    height: 201px;
  }
  p {
    display: -webkit-box;
    height: 45px;
    margin-top: 5px;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;
    font-size: 12px;
    line-height: 15px;
  }
}
@media screen and (max-width: 1300px) {
  .box {
    position: static;
    padding-left: 0;
  }
  .chart-pie {
    position: static;
    width: 100%;
  }
}
</style>
<style lang="less">
</style>
